module.exports = __webpack_public_path__ + "static/media/details.e798467f.svg";